<div class="main_wp enq_listing pikdrop_enq enq_dtl_card noscroll">
  <div class="conta_iner sp_auctions_bids">
    <div
      class="main_box"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolled)="onScrollingFinished()">
      @if (auctions().length > 0) {
        @if (userProfile) {
          <div class="column_container">
            <logibids-enquiry-card
              [auctions]="auctions()"
              [auctionType]="auctionType()"
              [userProfile]="userProfile"
              [showSkipButton]="true"
              source="driverEnquiryImmediate"
              (bidPlaced)="handleBidPlaced()"
              (auctionAccepted)="handleAuctionAccepted()"
              (skipAuction)="skip()">
            </logibids-enquiry-card>
          </div>
        }
      } @else if (isLoading()) {
        <div class="loader_wp">
          <p-progressSpinner ariaLabel="loading" />
        </div>
      } @else if (!isLoading()) {
        <div class="container noDataFound mt-3">
          <figure>
            <img
              [ngSrc]="assetsConst.noEnqueries"
              alt="noEnq"
              width="315"
              height="224"
              priority />
          </figure>
          <p class="text-center">{{ 'noEnquiriesFound' | translate }}</p>
        </div>
      }
    </div>
  </div>
</div>
